import Immutable from "immutable";

export class ReferenceCounts extends Immutable.Record({
  saved: 0,
  unsaved: 0,
}) {}
